import React, { useState } from "react";
import { toast } from "sonner";
import { UserCircle, KeyRound, Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CARD, Label } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function MonProfil() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [savingName, setSavingName] = useState(false);
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [np2, setNp2] = useState("");
  const [savingPw, setSavingPw] = useState(false);

  const saveName = async () => {
    if (name.trim().length < 2) { toast.error("Le nom doit contenir au moins 2 caractères"); return; }
    setSavingName(true);
    try {
      const { data } = await api.put("/auth/me", { name: name.trim() });
      setUser(data);
      toast.success("Profil mis à jour");
    } catch (e) { toast.error(apiErr(e)); } finally { setSavingName(false); }
  };

  const savePw = async () => {
    if (np.length < 10 || !/[A-Za-z]/.test(np) || !/\d/.test(np)) { toast.error("Le nouveau mot de passe doit contenir au moins 10 caractères, avec une lettre et un chiffre"); return; }
    if (np !== np2) { toast.error("Les deux mots de passe ne correspondent pas"); return; }
    setSavingPw(true);
    try {
      await api.put("/auth/me", { current_password: cur, new_password: np });
      toast.success("Mot de passe modifié");
      setCur(""); setNp(""); setNp2("");
    } catch (e) { toast.error(apiErr(e)); } finally { setSavingPw(false); }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <div>
        <p className="text-sm text-gray-400">Compte</p>
        <h1 className="font-display text-2xl font-bold sm:text-3xl">Mon profil</h1>
      </div>

      <div className={`${CARD} mt-5 p-6`}>
        <div className="mb-4 flex items-center gap-2 text-[#065F46]"><UserCircle className="h-5 w-5" /><h2 className="font-display text-lg font-bold">Informations</h2></div>
        <div className="space-y-4">
          <div><Label>Adresse e-mail</Label><Input value={user?.email || ""} disabled className="mt-1.5 rounded-xl bg-gray-50" data-testid="profile-email" /></div>
          <div><Label>Nom affiché</Label><Input data-testid="profile-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5 rounded-xl" /></div>
          <Button data-testid="save-name-btn" onClick={saveName} disabled={savingName} className="rounded-full bg-[#065F46] hover:bg-[#047857]">{savingName ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enregistrer"}</Button>
        </div>
      </div>

      {user?.auth_provider !== "google" && (
        <div className={`${CARD} mt-5 p-6`}>
          <div className="mb-4 flex items-center gap-2 text-[#065F46]"><KeyRound className="h-5 w-5" /><h2 className="font-display text-lg font-bold">Mot de passe</h2></div>
          <div className="space-y-4">
            <div><Label>Mot de passe actuel</Label><Input data-testid="current-password" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1.5 rounded-xl" /></div>
            <div><Label>Nouveau mot de passe</Label><Input data-testid="new-password" type="password" value={np} onChange={(e) => setNp(e.target.value)} className="mt-1.5 rounded-xl" /></div>
            <div><Label>Confirmer le nouveau mot de passe</Label><Input data-testid="new-password-confirm" type="password" value={np2} onChange={(e) => setNp2(e.target.value)} className="mt-1.5 rounded-xl" /></div>
            <Button data-testid="save-password-btn" onClick={savePw} disabled={savingPw} className="rounded-full bg-[#065F46] hover:bg-[#047857]">{savingPw ? <Loader2 className="h-4 w-4 animate-spin" /> : "Changer le mot de passe"}</Button>
          </div>
        </div>
      )}
    </div>
  );
}
